import {
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  FOLLOW_UP_PREVIEW,
  FOLLOW_UP_NEW,
  FOLLOW_UP_UPDATE,
  FOLLOW_UP_REMOVE,
  FOLLOW_UP_PROCESS_SUCCESS,
  FOLLOW_UP_DATASOURCE_SUCCESS,
  FOLLOW_UP_COMMENT_NEW,
  FOLLOW_UP_COMMENT_UPDATE,
  FOLLOW_UP_COMMENT_REMOVE,
  FOLLOW_UP_PROCESS_RESET,
  FOLLOW_UP_RESET_STATE,

  FOLLOW_UP_NOTIFICATION_REQUEST,
  FOLLOW_UP_NOTIFICATION_DATASOURCE,
  FOLLOW_UP_NOTIFICATION_DISMISS_UPDATE,
  FOLLOW_UP_NOTIFICATION_PROCESS_RESET,
  FOLLOW_UP_NOTIFICATION_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize: {},
  dataSource: [],
  process: {},
  keyword: ''
}

const NotificationState = {
  loader: false,
  dataSource: [],
  process: { status: false, action: "", message:"" }
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FOLLOW_UP_RESET_STATE: {
      return {
        loader: false,
        dataSerialize: {},
        dataSource: [],
        process: {},
        keyword: ''
      }
    }
    case FOLLOW_UP_PROCESS_RESET: {
      return {
        ...state,
        process: { status: false, action: "", message: "" },
        processAction: ""
      }
    }
    case FOLLOW_UP_PREVIEW: {
      return {
        ...state,
        loader: false,
        process: { status: false, action: "", message: "" },
        processAction: ""
      }
    }
    case FOLLOW_UP_NEW: {
      return {
        ...state,
        loader: true
      }
    }
    case FOLLOW_UP_UPDATE: {
      return {
        ...state,
        loader: true,
        dataSerialize: action.payload
      }
    }
    case FOLLOW_UP_REMOVE: {
      return {
        ...state,
        loader: false
      }
    }
    case FOLLOW_UP_PROCESS_SUCCESS: {
      return {
        ...state,
        loader: false,
        process: { ...action.payload }
      }
    }
    case FOLLOW_UP_DATASOURCE_SUCCESS: {
      return {
        ...state,
        loader: false,
        dataSource: action.payload
      }
    }
    case FOLLOW_UP_COMMENT_NEW: {
      return {
        ...state,
        loader: true
      }
    }
    case FOLLOW_UP_COMMENT_UPDATE: {
      return {
        ...state,
        loader: true,
        dataSerialize: action.payload
      }
    }
    case FOLLOW_UP_COMMENT_REMOVE: {
      return {
        ...state,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    default:
      return state
  }
}

export const FollowUpNotification = (state = NotificationState, action) => {
  switch (action.type) {
    case FOLLOW_UP_NOTIFICATION_REQUEST: {
      return {
        loader: true,
        dataSource: [],
        process: { status: false, action: "", message:"" }
      }
    }
    case FOLLOW_UP_NOTIFICATION_DISMISS_UPDATE: {
      return {
        ...state
      }
    }
    case FOLLOW_UP_NOTIFICATION_DATASOURCE: {
      return {
        ...state,
        loader: false,
        dataSource: action.payload
      }
    }
    case FOLLOW_UP_NOTIFICATION_PROCESS_RESET: {
      return {
        ...state,
        process: { status: false, action: "", message: "" }
      }
    }
    case FOLLOW_UP_NOTIFICATION_RESET: {
      return {
        loader: false,
        dataSource: [],
        process: { status: false, action: "", message:"" }
      }
    }
    default:
      return state
  }
}